import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { get } from "lodash-es";

export class LocationTypesRepository {
	private axios: Axios;

	constructor() {
		this.axios = axiosInstance;

		this.getLocationTypes = this.getLocationTypes.bind(this);
		this.getLocationTypeById = this.getLocationTypeById.bind(this);
	}

	async getLocationTypes() {
		try {
			const locationTypes = await this.axios.get("/LocationType/");

			return {
				ok: true,
				locationTypes: locationTypes.data,
			};
		} catch (error: any) {
			const message = get(
				error,
				"response.data.result",
				get(error, "response.data.detail", error.toString()),
			);
			return Promise.reject(message);
		}
	}

	async getLocationTypeById(locationTypeId: number | null) {
		try {
			const locationType = await this.axios.get(
				`/LocationType/${locationTypeId}`,
			);
			return {
				ok: true,
				locationType: locationType.data,
			};
		} catch (error) {
			return {
				ok: false,
				error,
			};
		}
	}
}

export const { getLocationTypes, getLocationTypeById } =
	new LocationTypesRepository();
